import React from 'react';
import Classrooms from './Classrooms';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';

const routes = getRoutes();

const ClassroomsModule: React.FC<ModuleProps> = moduleProps => {
  return <RouteModuleFactory IndexComponent={Classrooms} routes={routes} {...moduleProps} />;
};

export default ClassroomsModule;
